import React from "react";
import AccordionContainer from "components/shared/AccordionContainer";
import GenericContent from "./GenericContent";
import CodeSnippetElement from "./CodeSnippetElement";
import AccordionContent from "./AccordionContent";
import EmbeddableContent from "./EmbeddableContent";
import VideoElement from "./VideoElement";
import CarouselElement from "./CarouselElement";

const components = {
  GenericContent: GenericContent,
  CodeSnippetElement: CodeSnippetElement,
  AccordionContent: AccordionContent,
  EmbeddableContent: EmbeddableContent,
  VideoElement: VideoElement,
  CarouselElement: CarouselElement,
};

const renderElement = (element) => {
  const ElementName = components[element.type];
  return (
    <ElementName
      title={element.title}
      title_color={element.title_color}
      body={element.body}
      content={element.content}
      description={element.description}
      language={element.language}
      key={element.id}
      page_id={element.page_id}
      url={element.url}
      video_url={element.video_url}
      caption_url={element.caption_url}
      top_description={element.top_description}
      bottom_description={element.bottom_description}
      autoplay={element.autoplay}
      looping={element.looping}
      icon={element.icon}
    />
  );
};

const EmbeddedPageElement = ({ elements, title, title_color }) => {
  return (
    <AccordionContainer color={title_color} title={title}>
      <div className="flex f-d-column">{elements.map(renderElement)}</div>
    </AccordionContainer>
  );
};

export default EmbeddedPageElement;
